import { DndRowsPlugin } from '../plugins/row-dnd/DndRowsPlugin.js';
import { DndColumnsPlugin } from '../plugins/column-dnd/DndColumnsPlugin.js';
import { InfiniteScrollPlugin } from '../plugins/infinite-scrolling/InfiniteScrollPlugin.js';
import { EditablePlugin } from '../plugins/editable/EditablePlugin.js';
import { SortablePlugin } from '../plugins/sortable/SortablePlugin.js';
import { SelectablePlugin } from '../plugins/selectable/SelectablePlugin.js';
import { FilterablePlugin } from '../plugins/filterable/FilterablePlugin.js';
import { ToolbarPlugin } from '../plugins/toolbar/ToolbarPlugin.js';
import { PaginationPlugin } from '../plugins/pagination/PaginationPlugin.js';
import { VirtualizationPlugin } from '../plugins/virtualization/VirtualizationPlugin.js';
import { ExpandablePlugin } from '../plugins/expandable-grid/ExpandablePlugin.js';
import { GroupingPlugin } from '../plugins/grouping-grid/GroupingPlugin.js';
import { GroupingByPlugin } from '../plugins/grouping-by/GroupingByPlugin.js';
import '@babel/runtime/helpers/esm/defineProperty';
import '@babel/runtime/helpers/esm/toConsumableArray';
import 'react';
import 'react-sortable-hoc';
import '@elliemae/ds-icons/GripperVertical';
import '@elliemae/ds-utilities/utils';
import '@elliemae/ds-shared/useDataGrid/initColumnDefinition';
import '@elliemae/ds-shared/createDataInstance/createInstancePlugin';
import '@elliemae/ds-utilities/system';
import '../plugins/column-dnd/decorateGridWithDndColumns.js';
import '@babel/runtime/helpers/esm/slicedToArray';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import '@babel/runtime/helpers/esm/asyncToGenerator';
import '@babel/runtime/regenerator';
import '@elliemae/ds-utilities/hooks/useDerivedStateFromProps';
import '../plugins/editable/decorateEditable.js';
import 'react-edit';
import '@elliemae/ds-icons/EditPencil';
import '../plugins/editable/getEditorComponent.js';
import '@babel/runtime/helpers/esm/extends';
import '../plugins/editable/EditableComponents/ComboBox.js';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import '@elliemae/ds-basic/form/ComboBox';
import '../plugins/editable/EditableComponents/TextBox.js';
import '@elliemae/ds-basic/form/TextBox';
import 'sortabular';
import '../plugins/sortable/sortHeaderFormatter.js';
import '@elliemae/ds-classnames';
import '@elliemae/ds-icons/ArrowheadDown';
import '@elliemae/ds-icons/ArrowheadUp';
import '../plugins/sortable/useSortableState.js';
import 'sortabular/dist';
import '../plugins/sortable/checkIfSortable.js';
import '../plugins/sortable/sorter.js';
import 'moment';
import 'obj-str';
import '../plugins/selectable/addSelectableColumn.js';
import '../plugins/selectable/selectableFormatter.js';
import '@elliemae/ds-basic/form/Checkbox';
import '@elliemae/ds-basic/form/Radio';
import '../plugins/selectable/useSelectableState.js';
import '../plugins/selectable/helper.js';
import '../plugins/filterable/addFilterToColumn.js';
import '../plugins/filterable/filterableFormatter.js';
import '../plugins/filterable/components/FilterableHeader.js';
import 'prop-types';
import '@elliemae/ds-utilities/hooks/useResizeObserver';
import '@elliemae/ds-system/theme';
import '../plugins/filterable/components/filterable-menus/getFilterMenuByType.js';
import '../plugins/filterable/components/filterable-menus/DateRangeFilterMenu.js';
import '@elliemae/ds-date-range-picker';
import '@elliemae/ds-date-picker';
import '@elliemae/ds-basic/Popper';
import '@elliemae/ds-icons/DatePicker2';
import '@elliemae/ds-basic/Button';
import '../plugins/filterable/components/filterable-menus/defaultDateFormat.js';
import '../plugins/filterable/components/filterable-menus/SingleDateFilterMenu.js';
import '../plugins/filterable/components/filterable-menus/SingleRangeSwitcherMenu.js';
import '../plugins/filterable/components/filterable-menus/TextFilterMenu.js';
import 'lodash';
import '@elliemae/ds-dropdownmenu';
import '@elliemae/ds-menu';
import '@elliemae/ds-icons/SearchSmall';
import '../plugins/filterable/helper.js';
import '../plugins/filterable/filtering-helper/filterRowsByQuery.js';
import '../plugins/filterable/filtering-helper/strategiesOperators.js';
import 'comparejs';
import '../plugins/filterable/useFilterableState.js';
import 'uuid';
import '../plugins/toolbar/RowRenderer.js';
import '../plugins/toolbar/ToolbarTrigger.js';
import 'styled-components';
import '@elliemae/ds-icons/MoreOptionsVert';
import '../rowSizes.js';
import '@elliemae/ds-shared/FocusGroup/FocusGrid';
import '../plugins/pagination/helper.js';
import '../plugins/pagination/usePaginationState.js';
import '../components/NoResults.js';
import '@elliemae/ds-system';
import '../plugins/virtualization/VirtualizedBody.js';
import '../plugins/virtualization/VirtualizedBodyRow.js';
import '../plugins/virtualization/helper.js';
import 'react-window';
import '@elliemae/ds-icons/ArrowheadRight';
import '../plugins/expandable-grid/ExpandedRow.js';
import '@elliemae/ds-basic/Separator';
import '@elliemae/ds-shared/defer-render-hoc';
import '@elliemae/ds-shared/useDataGrid';
import '../components/BodyCell.js';
import '@elliemae/ds-shared/createDataInstance/utils';
import '@elliemae/ds-basic/TruncatedTooltipText';
import '../index-4a6329dc.js';
import '../components/renderers/defaultClassedRenderers.js';
import '../blockNames.js';
import '../components/renderers/renderRowsLoader.js';
import '../components/RowsLoader.js';
import '@elliemae/ds-basic/Spinner';
import '../components/TableBody.js';
import '../components/tableContext.js';
import '../components/Table.js';
import '../components/TableHeader.js';
import '../components/HeaderCell.js';
import '../plugins/column-sizing/ColumnSizingPlugin.js';
import '../plugins/column-sizing/useStylesheetHelpers.js';
import 'stylesheet-helpers';
import '../plugins/column-sizing/getColumnNameFromProperty.js';
import './getScrollbarSize.js';
import '../plugins/column-sizing/useColumnSizeService.js';
import '../plugins/column-sizing/utils.js';
import '../plugins/column-sizing/ext-points/getTableProps.js';
import '../plugins/column-sizing/ext-points/decorateColumn.js';
import '../plugins/column-sizing/columnMeasurerTransformer.js';
import '../plugins/expandable-grid/ExpandedRowExtra.js';
import '../plugins/expandable-grid/useExpandGridState.js';
import '@elliemae/ds-utilities/hooks/useExpandState';
import '../plugins/grouping-grid/walkStrategy.js';

var mapPropToPlugin = {
  dragAndDropColumns: DndColumnsPlugin,
  editable: EditablePlugin,
  selectable: SelectablePlugin,
  sortable: SortablePlugin,
  searchFilters: FilterablePlugin,
  renderToolbar: ToolbarPlugin,
  infiniteScrolling: InfiniteScrollPlugin,
  paginated: PaginationPlugin,
  virtualized: VirtualizationPlugin,
  expandable: ExpandablePlugin,
  groupedBy: GroupingByPlugin,
  groupedRows: GroupingPlugin,
  dragAndDropRows: DndRowsPlugin
};
function getPluginsFromProps(props) {
  var omit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var plugins = [];
  Object.keys(mapPropToPlugin).forEach(function (key) {
    if (props[key] && !omit[key]) plugins.push(mapPropToPlugin[key]);
  });
  return plugins;
}

export default getPluginsFromProps;
//# sourceMappingURL=getPluginsFromProps.js.map
